import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { PortfolioModel } from '@smarttask-common/src/lib/models/Portfolio/Core/PortfolioModel';

export enum PortfolioActionTypes {
    ADD_PORTFOLIO = '[Portfolio] Create Portfolio',
    ADD_PORTFOLIOS = '[Portfolio] Add Portfolios',
    UPSERT_PORTFOLIO = '[Portfolio] Upsert Portfolio',
    UPSERT_PORTFOLIOS = '[Portfolio] Upsert Portfolios',
    UPDATE_PORTFOLIO = '[Portfolio] Update Portfolio',
    UPDATE_PORTFOLIOS = '[Portfolio] Update Portfolios',
    DELETE_PORTFOLIO = '[Portfolio] Delete Portfolio',
    DELETE_PORTFOLIOS = '[Portfolio] Delete Portfolios',
    DELETE_ALL_PORTFOLIOS = '[Portfolio] Delete All Portfolios',
    DELETE_ALL = '[Portfolio] Delete All',

    UPDATE_SELECTED_ID = '[portfolio] Update SelectedId',
}

export class UpdateSelectedPortfolioId implements Action {
    readonly type = PortfolioActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_portfolio_id: string) {}
}

export class AddOne implements Action {
    readonly type = PortfolioActionTypes.ADD_PORTFOLIO;
    constructor(public portfolio: PortfolioModel) {}
}

export class AddMany implements Action {
    readonly type = PortfolioActionTypes.ADD_PORTFOLIOS;
    constructor(public portfolios: Array<PortfolioModel>) {}
}

export class UpsertOne implements Action {
    readonly type = PortfolioActionTypes.UPSERT_PORTFOLIO;
    constructor(public portfolio: PortfolioModel) {}
}

export class UpsertMany implements Action {
    readonly type = PortfolioActionTypes.UPSERT_PORTFOLIOS;
    constructor(public portfolios: Array<PortfolioModel>) {}
}

export class UpdateOne implements Action {
    readonly type = PortfolioActionTypes.UPDATE_PORTFOLIO;
    constructor(public portfolio: Update<PortfolioModel>) {}
}

export class UpdateMany implements Action {
    readonly type = PortfolioActionTypes.UPDATE_PORTFOLIOS;
    constructor(public portfolios: Array<Update<PortfolioModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = PortfolioActionTypes.DELETE_PORTFOLIO;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = PortfolioActionTypes.DELETE_PORTFOLIOS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = PortfolioActionTypes.DELETE_ALL_PORTFOLIOS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = PortfolioActionTypes.DELETE_ALL;
    constructor() {}
}

export type PortfolioActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedPortfolioId;
